@if (loading) {
  <app-loader></app-loader>
}
<app-header-audit-pending [count]="totalItems"></app-header-audit-pending>
@if (!loading && data.length === 0) {
  <app-empty-data
    message="No hay calentadores pendientes de auditoría."
  ></app-empty-data>
} @else {
  <ng-template #expanded let-row let-close="close">
    <app-expanded-component-audit-pending
      [row]="row"
      (onClose)="close()"
      (onApprove)="handleApproveSingle($event)"
      (onDeny)="handleDenySingle($event)"
    ></app-expanded-component-audit-pending>
  </ng-template>

  <app-filter-audit-pending
    [supplierList]="supplierList"
    [branchList]="branchList"
    [showActions]="selection.length > 0"
    (onApprove)="handleApproveSelection()"
    (onDeny)="handleDenySelection()"
    (onFilter)="getInventoryFiltered($event)"
  ></app-filter-audit-pending>

  @if (!loading) {
    <app-expandable-table
      [columns]="columns"
      [data]="data"
      [expandedTemplate]="expanded"
      buttonLabel="Ver detalles"
      [expandOnButtonClick]="true"
      (actionOnSelection)="setSelection($event)"
      [withCheckboxes]="true"
    >
    </app-expandable-table>
    <app-paginator
      [totalItems]="totalItems"
      [itemsPerPage]="limit"
      [currentPage]="page"
      (pageChange)="handlePageChange($event)"
      (limitChange)="handleLimitChange($event)"
    ></app-paginator>
  }
}
@if (showModal) {
  @if (actionKey === "approve") {
    <app-dialog
      (handleCancel)="handleCancelModal()"
      [title]="
        selection.length > 1
          ? `¿Está seguro de aprobar los ${selection.length} calentadores seleccionados?`
          : `¿Está seguro de aprobar el calentador ${selection[0].serial}?`
      "
      [showConfirm]="true"
      confirmText="Aprobar"
      (handleConfirm)="handleConfirmApproveSelection()"
      [showCancel]="true"
      cancelText="Cancelar"
      [closeOnOverlay]="false"
    >
    </app-dialog>
  } @else {
    <app-modal-deny-audit-pending
      [selection]="selection"
      (onCancel)="handleCancelModal()"
      (onConfirm)="handleConfirmDenySelection($event)"
    ></app-modal-deny-audit-pending>
  }
}
